import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { NumberStepper } from "@/components/NumberStepper";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Tag, X, Clock } from "lucide-react";

const NONE = "__none__";

export const BulkCategoryBar = ({ categories, selectable, selected, setSelected, onApply, onApplyDuration }) => {
  const [cat, setCat] = useState("");
  const [duration, setDuration] = useState(8);
  const ids = selectable.map((i) => i.id);
  const allChecked = ids.length > 0 && ids.every((id) => selected.has(id));

  const toggleAll = () => setSelected(allChecked ? new Set() : new Set(ids));
  const apply = () => {
    onApply(cat === NONE ? "" : cat);
    setSelected(new Set());
  };

  return (
    <div className="mb-3 flex flex-wrap items-center gap-3 rounded-xl border border-border bg-card/60 px-3 py-2" data-testid="bulk-category-bar">
      <label className="flex cursor-pointer items-center gap-2 text-xs text-muted-foreground">
        <Checkbox checked={allChecked} onCheckedChange={toggleAll} disabled={!ids.length} data-testid="bulk-select-all" />
        Tout sélectionner ({ids.length})
      </label>
      {selected.size > 0 && (
        <>
          <span className="text-xs font-semibold text-primary" data-testid="bulk-selected-count">
            {selected.size} sélectionnée{selected.size > 1 ? "s" : ""}
          </span>
          <Tag className="h-3.5 w-3.5 text-muted-foreground" />
          <Select value={cat} onValueChange={setCat}>
            <SelectTrigger className="h-8 w-48" data-testid="bulk-category-select"><SelectValue placeholder="Choisir une catégorie" /></SelectTrigger>
            <SelectContent>
              <SelectItem value={NONE}>Sans catégorie</SelectItem>
              {categories.map((c) => (
                <SelectItem key={c.id} value={c.id}>
                  <span className="flex items-center gap-2"><span className="h-2.5 w-2.5 rounded-full" style={{ background: c.color }} />{c.name}</span>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Button size="sm" onClick={apply} disabled={!cat} data-testid="bulk-apply-button">Appliquer</Button>
          <span className="mx-1 hidden h-5 w-px bg-border sm:block" />
          <Clock className="h-3.5 w-3.5 text-muted-foreground" />
          <NumberStepper value={duration} onChange={setDuration} min={1} max={600} testId="bulk-duration-input" />
          <Button size="sm" variant="secondary" onClick={() => onApplyDuration(duration)} data-testid="bulk-apply-duration-button">Appliquer la durée</Button>
          <Button size="sm" variant="ghost" onClick={() => setSelected(new Set())} data-testid="bulk-clear-button">
            <X className="mr-1 h-3.5 w-3.5" /> Désélectionner
          </Button>
        </>
      )}
    </div>
  );
};
